exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.warning[data-v-2ab84f7d] {\n  background-color: #e05050;\n  color: white;\n}\n.ok[data-v-2ab84f7d] {\n  background-color: #58cc1a;\n  color: white;\n}\n.content[data-v-2ab84f7d] {\n  display: inline-block;\n  vertical-align: top;\n}\n.content-icon[data-v-2ab84f7d] {\n  width: 5%;\n  margin: 5px 0 0 0;\n  text-align: center;\n}\n.content-text[data-v-2ab84f7d] {\n  width: 94%;\n  max-width: calc(100% - 30px);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-2ab84f7d","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Mobile/ReschedulingPage/SpNotificationBox.vue
// module id = 486
// module chunks = 0